import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import * as filters from '@/utils/filters'
import VueClipboard from 'vue-clipboard2'
import * as echarts from 'echarts';
import dark from '@/components/dark'
import moment from 'moment'


VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

echarts.registerTheme('dark', dark)

moment.locale()
Vue.prototype.$echarts = echarts
Vue.prototype.$moment = moment

Vue.config.productionTip = false

new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
}).$mount('#app')
